import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Scrolls to the top of the page on forward (PUSH) navigations — so opening a
 * detail page from a scrolled-down list starts at the top. POP navigations
 * (browser back/forward) are left alone so the browser can restore the prior
 * scroll position. Mount once inside the Router, above <Routes>.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [pathname, navigationType]);

  return null;
};

export default ScrollToTop;
